import React from "react";
import { useSelector } from "react-redux";
import { Chip } from "@mui/material";

const UserLevelChip = ({ level = 0 }) => {
  const levels = useSelector((state) => state.userLevel.levels);

  if (!levels || !level || levels.length === 0) return null;

  const matchedLevel = levels.find((l) => {
    return level >= l.startRange && level <= l.endRange;
  });
  if (!matchedLevel) return null;

  return (
    <Chip
      label={matchedLevel.name}
      sx={{
        backgroundColor: matchedLevel.color,
        minWidth: "50px",
        color: "white",
        fontWeight: "bold",
        fontSize: "1rem",
      }}
    />
  );
};

export default UserLevelChip;
